/* eslint-disable camelcase */
import { trackClick, trackPage } from "@companion-core/shared/app/tracking/index";
import ClickTypes from "@companion-core/shared/app/tracking/enums/click-types";
import ClicksEnum from "@companion-core/shared/app/tracking/enums/clicks";
import ChaptersEnum from "@companion-core/shared/app/tracking/enums/chapters";
import LevelsEnum from "@companion-core/shared/app/tracking/enums/levels";
import PagesEnum from "@companion-core/shared/app/tracking/enums/pages";
import { FilterCheckTracker } from "@companion-core/shared/app/Components/Inputs/JPInputFilter/JPInputFilter.model";

export type FiltersDisplayedTrackingContext =
  "default" | "web_desktop_category" | "web_desktop_localisation";

export const formatEnabledFiltersForTracking = (enabledFilters?: FilterCheckTracker[]) => {
  // Filters value should be like category1::item1|item2__category2::item1__category3::item1|item2|item3
  const formattedFilters = enabledFilters
    ?.filter((filter) => !!filter.checked.length)
    ?.map((filter) => `${filter.name}::${filter.checked.join("|")}`);
  return formattedFilters?.join("__");
};

export const trackFiltersDisplayed = ({
  enabledFilters,
  context = "default",
}: {
  enabledFilters?: FilterCheckTracker[];
  context?: FiltersDisplayedTrackingContext;
}) => {
  const page = context === "web_desktop_category" ? PagesEnum.FiltersCategory : PagesEnum.Filters;
  const page_chapter1 =
    context === "web_desktop_localisation"
      ? ChaptersEnum.FiltersLocalisation
      : ChaptersEnum.Filters;

  trackPage({
    page,
    page_chapter1,
    page_chapter2: formatEnabledFiltersForTracking(enabledFilters),
    site_level2: LevelsEnum.Dynamic,
  });
};

export const trackClickFiltersButton = () =>
  trackClick({
    click_type: ClickTypes.Navigation,
    click: ClicksEnum.OpenFilters,
    site_level2: LevelsEnum.Dynamic,
  });

export const trackClickFilter = ({
  filterCategoryClicked,
  filterItemClicked,
  enabledFilters,
}: {
  filterCategoryClicked: string;
  filterItemClicked: string;
  enabledFilters?: FilterCheckTracker[];
}) =>
  trackClick({
    click_type: ClickTypes.Action,
    click: ClicksEnum.FilterSelection,
    click_chapter1: `${filterCategoryClicked}::${filterItemClicked}`,
    click_chapter2: formatEnabledFiltersForTracking(enabledFilters),
    site_level2: LevelsEnum.Dynamic,
  });

/** Sélection d’une localisation (app & web), label tel qu’affiché pour l’utilisateur */
export const trackClickGeographicFilterSelection = (localisationLabel: string) =>
  trackClick({
    click_type: ClickTypes.Navigation,
    click: ClicksEnum.FilterSelection,
    click_chapter1: `vendor.localisation::${localisationLabel}`,
    site_level2: LevelsEnum.Dynamic,
  });

export const trackClickResetFilters = () =>
  trackClick({
    click_type: ClickTypes.Action,
    click: ClicksEnum.ClearAllFilters,
    site_level2: LevelsEnum.Dynamic,
  });

export const trackClickSearchFilter = (searchQuery: string) =>
  trackClick({
    click_type: ClickTypes.Action,
    click: ClicksEnum.Search,
    click_chapter1: searchQuery,
    site_level2: LevelsEnum.Dynamic,
  });
